// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import TouchCardLayerBase from "../common/TouchCardLayerBase";
import ChooseCardChallengeItem from "./ChooseCardChallengeItem";
import ChooseCardChallengeItemShow from "./ChooseCardChallengeItemShow";
import ChooseCardChallengeResult from "./ChooseCardChallengeResult";
import { ChooseCardDataManage } from "./data/ChooseCardDataManage";
import { ChooseCardKind } from "./data/ChooseCardKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ChooseCardChallengeLayer extends TouchCardLayerBase {

	@property({ type: cc.Button, displayName:'' })
	btnRight: cc.Button = null;

	@property({ type: cc.Button, displayName:'' })
	btnLeft: cc.Button = null;

	@property({ type: cc.Label, displayName:'' })
	labelNum: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSelectLayout: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeReferLayout2: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeReferLayout1: cc.Node = null;
    

    @property(cc.Prefab)
    prefabSelect: cc.Prefab = null;
    @property(cc.Prefab)
    prefabShow: cc.Prefab = null;

    @property(cc.Prefab)
    prefabResult: cc.Prefab = null;

     /** 牌型数据 */
    private cardType: ChooseCardKind.CardType = null;
    private cardData: ChooseCardKind.CardTypeData = null;

    /** 当前选择的牌 */
    private curSelectList: number[] = [];

    /** 当前第几张牌 */
    private curCardIdx = 0;

    private curAnewOneCount = 0;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        super.start();

        this.resetData();
    }

    resetData() {
        this.cardTouch.setTouchState(true);
        this.btnRight.interactable = true;
    	this.btnLeft.interactable = true;
        this.curAnewOneCount = 0;
        this.curCardIdx = 0;
        this.curSelectList = [];
        super.resetData();

        this.getCardTypeData();

        this.resetReferArea();
        this.resetSelectArea();
        this.showSelectCard();
    }

    /**
     * 获得牌型数据
     * @returns 
     */
    getCardTypeData() {
        const c_len = 3;

        this.cardType = data_control.randomNumInt(0, c_len-1);
        let cardData = ChooseCardDataManage.generateCardType(this.cardType);
        this.cardData = cardData;

        this.cardData.card.sort((a, b)=> a-b);
        return cardData;
    }

    resetSelectArea() {
        this.nodeSelectLayout.removeAllChildren();

        const c_len = 6;
        let winCount = 1;
        let winCard = this.cardData.winCard;
        if (winCard.length >= 2) {
            winCount = data_control.randomNumInt(1, winCard.length);
        }
        let cardData = ChooseCardDataManage.getSelectCardData(c_len-winCount, winCard);
        if (winCard.length >= 2 && winCount != winCard.length) {
            let idx = data_control.randomNumInt(0, winCard.length-1);
            cardData.push(winCard[idx]);
        } else {
            cardData = cardData.concat(winCard);
        }
        this.curSelectList = cardData = data_control.randomSortArray(cardData);

        // console.log('--- 胡的牌', winCard);
        // console.log('---选择的牌 ', cardData);
        
        for (let i = 0; i < cardData.length; i++) {
            let d = cardData[i];
            let nodeItem = cc.instantiate(this.prefabSelect);
            this.nodeSelectLayout.addChild(nodeItem);
            
            let script = nodeItem.getComponent(ChooseCardChallengeItem);
            script.setData(d, this, i);
        }
    }

    /**
     * 参照区
     */
    resetReferArea(){
        this.nodeReferLayout1.removeAllChildren();
        this.nodeReferLayout2.removeAllChildren();
        // 牌
        const cardCount1 = 7;
        for (let i = 0; i < cardCount1; i++) {
            let card = this.cardData.card[i];
            this.generateBaseCard(card, this.nodeReferLayout1);
        }
        for (let i = cardCount1; i < this.cardData.card.length; i++) {
            let card = this.cardData.card[i];
            this.generateBaseCard(card, this.nodeReferLayout2);
        }
    }

    /**
     * 生成牌
     * @param card 
     * @param parent 
     */
    generateBaseCard(card: number, parent: cc.Node) {
        let nodeItem = cc.instantiate(this.prefabShow);
        parent.addChild(nodeItem);

        let script = nodeItem.getComponent(ChooseCardChallengeItemShow);
        script.setData(card, this);
    }

    showSelectCard() {
        this.cardTouch.setData(this.curSelectList[this.curCardIdx], this);
        let children = this.nodeSelectLayout.children;
        let script = children[this.curCardIdx].getComponent(ChooseCardChallengeItem);
        script.setSelect(true);

        this.labelNum.string = '第' + (this.curCardIdx+1) + '张';
    }

    selectCard(idx: number) {
        let children = this.nodeSelectLayout.children;
        let script = children[this.curCardIdx].getComponent(ChooseCardChallengeItem);
        script.setSelect(false);

        this.curCardIdx = idx;
        this.showSelectCard();
    }

    selectNextCard(bNext: boolean) {
        let children = this.nodeSelectLayout.children;
        let len = children.length;
        let cidx = this.curCardIdx;
        while(true) {
            cidx += (bNext ? 1 : -1);
            let idx = (cidx + len) %len;
            let script = children[idx].getComponent(ChooseCardChallengeItem);
            if (script.isCanUse()) {
                this.selectCard(idx);
                return;
            }
        }
    }

    anewOneCard(idx: number) {
        this.curAnewOneCount++;
        this.setSelectListEnable(true);
        
        let children = this.nodeSelectLayout.children;
        let script = children[idx].getComponent(ChooseCardChallengeItem);
        script.setValid(false);

        if (this.curCardIdx == idx) {
            this.selectNextCard(true);
        }
    }

    onClickLeft() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.selectNextCard(false);
    }

    onClickRight() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.selectNextCard(true);
    }

    setSelectListEnable(enable: boolean) {
        this.cardTouch.setTouchState(enable);
        this.btnRight.interactable = enable;
    	this.btnLeft.interactable = enable;
        let children = this.nodeSelectLayout.children;
        children.forEach((v)=> {
            let script = v.getComponent(ChooseCardChallengeItem);
            script.setCanUse(enable);
        });
    }

    async showRet(card: number, idx: number) {
        this.setSelectListEnable(false);
        await new Promise<void>(resolve=>{
            cc.tween(this.node).delay(0.5).call(resolve).start();
        });

        if (!this.node || !cc.isValid(this.node)) {
            return;
        }
        let bCanAnewOne = this.curAnewOneCount < 2;
        let resultNode = cc.instantiate(this.prefabResult);
        this.node.addChild(resultNode);

        let bwin = this.cardData.winCard.includes(card);

        let script = resultNode.getComponent(ChooseCardChallengeResult);
        script.setData(card, this, this.getLotteryInfo(), bwin, bCanAnewOne, idx);
    }

    // update (dt) {}
}
